import Vue from 'vue';
import { Question } from '@/models/quiz';

export default class QuizRunner extends Vue {
    public quizQuestion: Question;
    public finishedCallback: () => void;

    public constructor(quizQuestion: Question, finished?: () => void) {
        super();
        this.quizQuestion = quizQuestion;
        this.finishedCallback = finished;
    }

    public t(key: string): string {
        return this.$store.$t(key) as string;
    }

    public start() {
        this.$f7.dialog
            .create({
                title: this.t('quiz.ready_title'),
                text: this.t('quiz.ready_text'),
                buttons: [{ text: this.t('quiz.ready_cancel') }, { text: this.t('quiz.ready_start') }],
                onClick: (_, index) => {
                    if (index === 1) this.showQuizQuestion();
                }
            })
            .open();
    }

    public showQuizQuestion() {
        this.$f7.dialog
            .create({
                title: this.t('quiz.question_title'),
                text: this.quizQuestion.question,
                buttons: [
                    { text: this.quizQuestion.answer1 },
                    { text: this.quizQuestion.answer2 },
                    { text: this.quizQuestion.answer3 },
                    { text: this.quizQuestion.answer4 }
                ],
                verticalButtons: true,
                onClick: (_, index) => this.onAnswerGiven(index + 1)
            })
            .open();
    }

    public async onAnswerGiven(answer: number) {
        const correctAnswer = this.quizQuestion.correct_answer === answer;

        const notAnsweredYet = this.$store.quizAnswers.find(a => a.questionId === this.quizQuestion.id) === undefined;
        if (notAnsweredYet) {
            this.$store.quizAnswers.push({
                questionId: this.quizQuestion.id,
                answer: answer,
                correct: correctAnswer,
                time: new Date()
            });

            await this.$store.saveQuizAnswers();
        }

        if (correctAnswer) {
            this.onAnswerCorrect();
        } else {
            this.onAnswerWrong();
        }

        if (this.finishedCallback) {
            this.finishedCallback();
        }
    }

    public onAnswerCorrect() {
        this.$f7.dialog.alert(this.t('quiz.correct_text'), this.t('quiz.correct_title'));
    }

    public onAnswerWrong() {
        this.$f7.dialog.alert(this.t('quiz.wrong_text'), this.t('quiz.wrong_title'));
    }
}
